import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { FilterTransactionDto } from '../../dtos/transaction.dto';
import { TransactionActionTypes as actions } from './actionTypes';

export const getPayment = (data: FilterTransactionDto) => {
    return {
        payload: data,
        type: actions.GET_PAYMENT,
    };
};
export const setPayment = (data: any): GeneralAction<actions> => {
    return {
        payload: data,
        type: actions.SET_PAYMENT
    };
};

export const getPaymentDetail = (data: any): GeneralAction<actions> => {
    return {
        payload: data,
        type: actions.GET_PAYMENT_DETAILS
    };
};
export const setPaymentDetail = (data: any): GeneralAction<actions> => {
    return {
        payload: data,
        type: actions.SET_PAYMENT_DETAILS
    };
};

export const downloadCsv = (data: any): GeneralAction<actions> => {
    return {
        payload: data,
        type: actions.DOWNLOAD_CSV
    };
};

export const downloadCsvSuccess = (data: any): GeneralAction<actions> => {
    return {
        type: actions.DOWNLOAD_CSV_SUCCESS,
        payload: data
    };
};

export const downloadCsvFailure = (data: any): GeneralAction<actions> => {
    return {
        type: actions.DOWNLOAD_CSV_FAILURE,
        payload: data
    };
};

export const saveTransactionFilter = (data: any): GeneralAction<actions> => {
    return {
        payload: data,
        type: actions.SAVE_TRANSACTION_FILTER
    };
};

export const clearTransactionFilter = (): GeneralAction<actions> => {
    return {
        type: actions.CLEAR_TRANSACTION_FILTER
    };
};
